module.exports = "<div class=\"mt-4\" style=\"width:100%\" >\n    <ContentLoader :primaryColor=\"dtPalette['grey-3']\">\n        <rect x=\"0\" y=\"0\" rx=\"2\" ry=\"2\" width=\"48\" height=\"5\" />\n        <rect x=\"55\" y=\"0\" rx=\"2\" ry=\"2\" width=\"48\" height=\"5\" /> \n    </ContentLoader>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/loaders/ticket-list-texts-loader/template.html
// module id = 8a98
// module chunks = 0